import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning, IoWarningOutline } from "react-icons/io5";
import { LuArrowLeft, LuCalendarDays, LuCirclePlay, LuLock, LuUserRound } from "react-icons/lu";
import ReactPlayer from "react-player";
import { Link, useParams } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import { serverInstance } from "../../service/axios";
import "./training.scss";

class TrainingModel {
  id
  title
  description
  year
  authors
  keywords
  exclusive
  fileUrl
}

const Training = ({ data }) => {
  const params = useParams();
  const { userData } = useContext(ClientAuthContext)
  const [available, setAvailable] = useState(false);
  const [training, setTraining] = useState(new TrainingModel());
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const isMembershipActive = Boolean(userData?.paid_until && new Date(userData.paid_until) > new Date());
  const trainingImageUrl = training.fileUrl2
    ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${training.fileUrl2}`
    : "";
  const isEnglish = data?.title === "Training";
  const backLabel = isEnglish ? "Back to training" : "Сургалтууд руу буцах";
  const detailsLabel = isEnglish ? "Training details" : "Сургалтын мэдээлэл";
  const videoLabel = isEnglish ? "Training video" : "Сургалтын видео";

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      setAvailable(false);
      serverInstance.post("/app/item", { class: "training", id: params.id }, {
        headers: {
          "Content-Type": "application/json",
        }
      })
        .then(res => {
          const item = res.data.item || {};
          const normalizedItem = {
            ...item,
            fileUrl: item.fileUrl
              ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`
              : "",
          };
          setTraining(normalizedItem)
          if (normalizedItem.exclusive) {
            checkIfUserHasAccess(normalizedItem.id);
          }
          else {
            setAvailable(true);
          }
          setLoading(false);
          setErrorMsg("");
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg(err?.response?.data?.message || err?.message || String(err));
        })
    }
  }, [params.id]);

  const checkIfUserHasAccess = (id) => {
    const token = localStorage.getItem("msidclienttoken")
    serverInstance.get("/training/client/" + id, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      })
      .then(res => {
        setAvailable(res.data.available);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg("Хандах эрхийг шалгахад алдаа гарлаа.");
        console.error(err);
      })
  }

  return (
    <div className="training">
      {loading ? (
        <div className="training-loading">
          <AiOutlineLoading3Quarters size={28} className="loading-spinner" />
        </div>
      ) : (
        <main className="training-shell">
          <Link className="training-back-link" to="/training">
            <LuArrowLeft aria-hidden="true" />
            <span>{backLabel}</span>
          </Link>

          {errorMsg ? (
            <div className="error-msg">
              <IoWarning />
              <span>{errorMsg}</span>
            </div>
          ) : null}

          {!errorMsg ? (
            <>
              <section className={"training-hero" + (trainingImageUrl ? "" : " training-hero-no-image")}>
                {trainingImageUrl ? (
                  <div className="training-img">
                    <img src={trainingImageUrl} alt={training.title || ""} />
                  </div>
                ) : null}

                <div className="training-hero-copy">
                  <div className="training-eyebrow">
                    <LuCirclePlay aria-hidden="true" />
                    <span>{data.title}</span>
                  </div>
                  <h1 className="title">{training.title}</h1>

                  <div className="training-dets">
                    {training?.authors?.length > 0 ? (
                      <div className="training-det">
                        <LuUserRound aria-hidden="true" />
                        <div>
                          <span className="training-det-label">{data.author}</span>
                          <span className="training-det-value">{training.authors.join(", ")}</span>
                        </div>
                      </div>
                    ) : null}
                    {training?.year ? (
                      <div className="training-det">
                        <LuCalendarDays aria-hidden="true" />
                        <div>
                          <span className="training-det-label">{data.year}</span>
                          <span className="training-det-value">{training.year}</span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </section>

              <div className="training-content-grid">
                <section className="training-story">
                  <h2>{detailsLabel}</h2>
                  <div className="training-desc">{training.description}</div>
                </section>

                <section className="training-access">
                  <h2>{videoLabel}</h2>
                  {!isMembershipActive ? (
                    <div className="access-message payment">
                      <IoWarningOutline aria-hidden="true" />
                      <span>{data.payment}</span>
                    </div>
                  ) : available ? (
                    <div className="video-container">
                      <ReactPlayer
                        className="video-player"
                        controls={true}
                        width="100%"
                        height="100%"
                        url={training.fileUrl}
                        fallback={<AiOutlineLoading3Quarters size={25} />}
                      />
                    </div>
                  ) : (
                    <div className="access-message exclusive">
                      <LuLock aria-hidden="true" />
                      <span>{data.exclusive}</span>
                    </div>
                  )}
                </section>
              </div>
            </>
          ) : null}
        </main>
      )}
    </div>
  );
}

export default Training;
